import { apiJson } from '../api';

export interface PipelineSetting {
  key: string;
  value: string;
  description: string;
  type: string;
  default: string;
  min?: number | null;
  max?: number | null;
  updated_at: string | null;
  updated_by: string | null;
  is_default: boolean;
}

export function getPipelineSettings(): Promise<PipelineSetting[]> {
  return apiJson<PipelineSetting[]>('/api/admin/pipeline/settings');
}

export function updatePipelineSetting(key: string, value: string): Promise<PipelineSetting> {
  return apiJson<PipelineSetting>(`/api/admin/pipeline/settings/${key}`, {
    method: 'PUT',
    json: { value },
  });
}
